import interact from 'interactjs';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Inject, Prop, Ref } from 'vue-property-decorator';

import { DesignerElement, IDesignerElementSize } from './models/designer-element.model';
import { removeElement } from './designer-tools.utils';
import { DesignerStateProvider } from './designer.provider';
import ToolsProvider from '@/providers/tools';

@Component({})
export default class DesignerElementsMixin extends Vue {
  @Prop() value: DesignerElement;
  @Prop({ default: '' }) readonly elementId: string;

  @Inject()
  readonly DesignerStateProvider: DesignerStateProvider;

  @Ref() readonly elementDesigner: any;

  interactModifiers = [];
  resizeEdgesOptions: any = {
    left: '.resize--left',
    right: '.resize--right',
    bottom: '.resize--bottom',
    top: '.resize--top'
  };

  get selected() {
    return this.DesignerStateProvider.elementSelected?.id === this.value.id;
  }

  get containerClasses() {
    return {
      'selected': this.selected,
    };
  }

  mounted() {
    this.init();
  }

  init() {
    this.initSizes();
    this.registerHTMLElement(); 
     
    this.initInteract(
      this.elementDesigner,
      this.interactModifiers,
      this.resizeEdgesOptions
    );
  }

  registerHTMLElement() {
    this.value.setHTMLElement(this.$el as any);
    this.value.setDraggable();
  }

  async initSizes() {
    const sizes = this.value.sizes;
    
    if (sizes) {
      this.elementDesigner.style.width = `${sizes.width}px`;
      this.elementDesigner.style.height = `${sizes.height}px`;
    } else {
      await ToolsProvider.sleep(100);

      this.value.sizes = {
        width: this.elementDesigner.offsetWidth,
        height: this.elementDesigner.offsetHeight,
      };
    }
  }

  initInteract(htmlElement, modifiers = [], edges = this.resizeEdgesOptions) {
    interact(htmlElement)
      .resizable({ edges, modifiers, })
      .on('resizemove', this.onResizeElement);
  }

  onResizeElement(event) {
    const target = event.target as HTMLElement;
    let x = (parseFloat(target.getAttribute('data-x')) || 0);
    let y = (parseFloat(target.getAttribute('data-y')) || 0);

    target.style.width = `${event.rect.width}px`;
    target.style.height = `${event.rect.height}px`;

    x += event.deltaRect.left;
    y += event.deltaRect.top;

    target.style.transform = `translate(${x}px, ${y}px)`;
    target.setAttribute('data-x', x.toString());
    target.setAttribute('data-y', y.toString());

    this.value.sizes = {
      width: event.rect.width,
      height: event.rect.height,
    };
  }

  onSelectElement() {
    this.DesignerStateProvider.elementSelected = this.value;
  }

  onRemoveElement() {
    this.DesignerStateProvider.executeAction({
      action: removeElement,
    })
  }
}